import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';
 
import { BoxMenuTheme } from './themes/types';
import Card from '@plasma/ui.display.card';
import Icon from '@plasma/ui.general.icon';
 
const styled = baseStyled as ThemedStyledInterface<BoxMenuTheme>;
const css = baseCss as ThemedCssFunction<BoxMenuTheme>;
 
export const BoxMenyIconContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;
 
export const StyledIcon = styled(Icon)<{ iconSize: string }>`
  && {
    font-size: ${({ iconSize }) => `${iconSize}px`};
    color: ${(props) => props.theme.mode.BoxMenu.textColor};
  }
`;
 
 
export const StyledCard = styled(Card)<{ disabled: boolean }>`
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease-in-out, box-shadow 0.3s ease, background 0.3s ease-in-out;
  margin: 18px;
  background-color: ${(props) => props.theme.mode.BoxMenu.backgroundColor};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 15px;
  align-items: center;
  height: 15vh;
  transform-origin: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};  /* Dim the card if disabled */
 
  &:hover {
    transform: ${(props) => (props.disabled ? 'none' : 'scale(1.07)')};  /* Apply scale only if not disabled */
    box-shadow: ${(props) => (props.disabled ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.2)')};  /* Example of adding shadow */
  }
`;
 
export const BoxMenuTitle = styled.div<{ fontSize: string }>`
  color: ${(props) => props.theme.mode.BoxMenu.textColor};
  background-color: ${(props) => props.theme.mode.BoxMenu.backgroundColor};
  text-color:  ${(props) => props.theme.mode.BoxMenu.textColor};
  display: flex;
  justify-content: center;
  width: 7.5vw;
  margin-bottom: 1vh;
  background-color: none;
  font-size: ${({ fontSize }) => `${fontSize}px`};
  font-weight: bold;
`;